module.exports = __webpack_public_path__ + "static/media/plant.b43551e8.png";